import { defaultDialogSetupBuilder } from '@/components/services/dialog/dialogSetup';

export default (invokeArgs = {}) => {
  defaultDialogSetupBuilder(
    {
      isModalShown: true,
      confirmTitle: 'Activate account',
      confirmText: 'Are you sure you want to activate account? You will be able to undo this action.',
      confirmBtnColor: 'statusActive',
      confirmBtnText: 'Activate',
      ...invokeArgs,
    },
  );
};
